import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

const useQueryParams = () => {
  const { search } = useLocation();

  return useMemo(() => {
    const params = new URLSearchParams(search);
    const result = {};
    for (let [key, value] of params.entries()) {
      result[key] = value;
    }
    return result;
  }, [search]);
};

export default useQueryParams;
